import { useMemo } from 'react';
import { DetailedSourceLanguageResponse } from 'src/types/languagesDomain';
import { useTargetLanguagesContext } from 'src/context/targetLanguages';

type MultiTargetLanguagePair = {
  sourceLanguageLocale: string;
  targetLanguageBaseLocale: string;
  targetLanguageLocales: DetailedSourceLanguageResponse[];
};

export const useMultiTargetLanguagePairs = (): MultiTargetLanguagePair[] => {
  const targetLanguages = useTargetLanguagesContext();
  const getBaseLocale = (locale: string) => locale.split('-')[0];

  return useMemo(() => {
    const multiTargetLPs: MultiTargetLanguagePair[] = [];

    targetLanguages.forEach(languagePair => {
      const { sourceLanguageLocale, targetLanguageLocale } = languagePair;
      const targetLanguageBaseLocale = getBaseLocale(targetLanguageLocale);
      const multiTargetLP = multiTargetLPs.find(
        bl =>
          bl.sourceLanguageLocale === sourceLanguageLocale &&
          bl.targetLanguageBaseLocale === targetLanguageBaseLocale,
      );

      if (multiTargetLP) {
        multiTargetLP.targetLanguageLocales.push(languagePair);
      } else {
        multiTargetLPs.push({
          sourceLanguageLocale,
          targetLanguageBaseLocale,
          targetLanguageLocales: [languagePair],
        });
      }
    });

    return multiTargetLPs;
  }, [targetLanguages]);
};
